import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            className="border-none text-white shadow-[0_18px_40px_-14px_rgba(90,55,140,0.55)] bg-gradient-to-r from-[#b89dd4] to-[#7a5aa2]"
          >
            <div className="grid gap-1">
              {title && (
                <ToastTitle className="text-white text-[0.95rem] font-semibold leading-snug">
                  {title}
                </ToastTitle>
              )}
              {description && (
                <ToastDescription className="text-white/90 text-[0.85rem] leading-snug">
                  {description}
                </ToastDescription>
              )}
            </div>
            {action}
            <ToastClose className="text-white/90 hover:text-white opacity-100" />
          </Toast>
        );
      })}
      <ToastViewport className="fixed top-4 right-4 left-4 sm:left-auto sm:top-auto sm:bottom-6 sm:right-6 z-[200] flex max-h-screen w-auto sm:w-full sm:max-w-[400px] flex-col p-0" />
    </ToastProvider>
  );
}
